/* D' todo con Pablito — Scripts v3 */
(function () {
  'use strict';

  /* Device SVG glyphs */
  var glyphs = {
    phone:  '<svg viewBox="0 0 48 48" fill="none" stroke="currentColor" stroke-width="2.2"><rect x="15" y="6" width="18" height="36" rx="4"/><line x1="21" y1="38" x2="27" y2="38"/></svg>',
    watch:  '<svg viewBox="0 0 48 48" fill="none" stroke="currentColor" stroke-width="2.2"><rect x="16" y="16" width="16" height="16" rx="5"/><path d="M19 16l1-6h8l1 6M19 32l1 6h8l1-6"/></svg>',
    buds:   '<svg viewBox="0 0 48 48" fill="none" stroke="currentColor" stroke-width="2.2"><path d="M18 12c-3 0-5 3-5 7s2 6 4 6 3-2 3-5V14c0-1-1-2-2-2Z"/><path d="M30 12c3 0 5 3 5 7s-2 6-4 6-3-2-3-5V14c0-1 1-2 2-2Z"/></svg>',
    tablet: '<svg viewBox="0 0 48 48" fill="none" stroke="currentColor" stroke-width="2.2"><rect x="10" y="8" width="28" height="32" rx="4"/><line x1="22" y1="35" x2="26" y2="35"/></svg>',
    case:   '<svg viewBox="0 0 48 48" fill="none" stroke="currentColor" stroke-width="2.2"><rect x="16" y="8" width="16" height="32" rx="4"/><circle cx="20" cy="14" r="1.6" fill="currentColor"/><circle cx="24" cy="14" r="1.6" fill="currentColor"/></svg>'
  };

  function initGlyphs() {
    document.querySelectorAll('.glyph[data-g]').forEach(function (el) {
      el.innerHTML = glyphs[el.dataset.g] || glyphs.phone;
    });
  }

  /* FAQ accordion */
  function initFaq() {
    document.querySelectorAll('.dp-q button').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var q = btn.parentElement;
        var ans = q.querySelector('.ans');
        var isOpen = q.classList.contains('open');
        document.querySelectorAll('.dp-q').forEach(function (x) {
          x.classList.remove('open');
          x.querySelector('.ans').style.maxHeight = null;
        });
        if (!isOpen) {
          q.classList.add('open');
          ans.style.maxHeight = ans.scrollHeight + 'px';
        }
      });
    });
  }

  /* Countdown timer */
  function initCountdown() {
    var els = document.querySelectorAll('[data-countdown]');
    if (!els.length) return;
    els.forEach(function (wrap) {
      var hours = parseInt(wrap.getAttribute('data-countdown'), 10) || 48;
      var end = Date.now() + hours * 3600000;
      var dEl = wrap.querySelector('[data-cd-d]');
      var hEl = wrap.querySelector('[data-cd-h]');
      var mEl = wrap.querySelector('[data-cd-m]');
      var sEl = wrap.querySelector('[data-cd-s]');
      function pad(n) { return String(n).padStart(2, '0'); }
      function tick() {
        var t = Math.max(0, end - Date.now());
        if (dEl) dEl.textContent = pad(Math.floor(t / 86400000));
        if (hEl) hEl.textContent = pad(Math.floor(t / 3600000) % 24);
        if (mEl) mEl.textContent = pad(Math.floor(t / 60000) % 60);
        if (sEl) sEl.textContent = pad(Math.floor(t / 1000) % 60);
        if (t > 0) setTimeout(tick, 1000);
      }
      tick();
    });
  }

  /* Reveal on scroll */
  function initReveal() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      document.querySelectorAll('.reveal').forEach(function (el) { el.classList.add('in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12 });
    document.querySelectorAll('.reveal').forEach(function (el) { io.observe(el); });
  }

  /* Shipping progress bar */
  function initShipBar() {
    var threshold = 499;
    document.querySelectorAll('.dp-ship-bar').forEach(function (bar) {
      var price = parseFloat(bar.getAttribute('data-price') || '0');
      var pct = Math.min(100, Math.round(price / threshold * 100));
      var remaining = Math.max(0, threshold - price);
      var fill = bar.querySelector('.dp-ship-bar-fill');
      var label = bar.querySelector('.dp-ship-bar-label');
      if (fill) fill.style.width = pct + '%';
      if (label) {
        label.innerHTML = remaining > 0
          ? 'Add <b>$' + remaining + ' more</b> for free shipping'
          : '<b>🎉 Free shipping unlocked!</b>';
      }
    });
  }

  /* Split price into sym + int + cents for Back Market style */
  function initPriceSplit() {
    document.querySelectorAll('.dp-price-split').forEach(function (el) {
      if (el.dataset.split) return;
      el.dataset.split = '1';
      var raw = el.textContent;
      var m = raw.match(/([^\d]*?)\s*([\d,]+)[.,](\d+)/);
      if (!m) {
        var m2 = raw.match(/([^\d]*?)\s*([\d,]+)/);
        if (!m2) return;
        el.innerHTML = (m2[1].trim() ? '<span class="dp-p-sym">' + m2[1].trim() + '</span>' : '') + '<span class="dp-p-int">' + m2[2] + '</span>';
        return;
      }
      el.innerHTML =
        (m[1].trim() ? '<span class="dp-p-sym">' + m[1].trim() + '</span>' : '') +
        '<span class="dp-p-int">' + m[2] + '</span>' +
        '<span class="dp-p-dec">.' + m[3] + '</span>';
    });
  }

  /* Style filter pills like Back Market */
  /* Rename Spanish filter names to English */
  function initFilterNames() {
    document.querySelectorAll('.facets__summary, .facets__heading, .mobile-facets__summary, button[data-index]').forEach(function(el) {
      var txt = el.textContent;
      if (txt.includes('Estado estético') || txt.includes('estado estético')) {
        el.childNodes.forEach(function(node) {
          if (node.nodeType === 3) node.textContent = node.textContent.replace(/Estado estético/gi, 'Condition');
        });
        var spans = el.querySelectorAll('span:not(.facets__selected):not(.visually-hidden)');
        spans.forEach(function(s) { s.textContent = s.textContent.replace(/Estado estético/gi, 'Condition'); });
      }
    });
  }

  function initFacetsPills() {
    var summaries = document.querySelectorAll('.facets__summary');
    if (!summaries.length) return;
    summaries.forEach(function (el) {
      el.style.cssText += ';display:inline-flex!important;align-items:center!important;padding:8px 18px!important;margin-bottom:0!important;background:#fff!important;border:1.5px solid #d1d5db!important;border-radius:999px!important;cursor:pointer!important;white-space:nowrap!important;font-weight:500!important;color:#0A1A2F!important;font-family:Inter,system-ui,sans-serif!important;font-size:14px!important;';
    });
  }

  /* ── Página de producto ── */

  /* Re-inicializar completamente cuando Dawn actualiza el precio */
  function reinitProductActions() {
    var wrapper = document.querySelector('.dp-price-with-btn');
    if (!wrapper) {
      initProductActions();
    } else {
      updateProxyBtn();
      updateSavingsBadge();
    }
    ensureVariantChecked();
  }

  /* Si al cambiar de variante ninguna opción quedó marcada visualmente, forzar la primera disponible */
  function ensureVariantChecked() {
    document.querySelectorAll('.product-form__input--pill, .product-form__input--swatch').forEach(function(fieldset) {
      var radios = fieldset.querySelectorAll('input[type="radio"]');
      if (!radios.length) return;

      function isVisible(r) {
        var label = r.nextElementSibling;
        return !(label && getComputedStyle(label).display === 'none');
      }
      function isSelectable(r) {
        return isVisible(r) && !r.disabled && !r.classList.contains('disabled') && !r.classList.contains('visually-disabled');
      }

      var checkedVisible = false;
      radios.forEach(function(r) { if (r.checked && isVisible(r)) checkedVisible = true; });
      if (checkedVisible) return;

      /* Nada visible está marcado (puede que lo marcado esté oculto por no combinar con el color actual) */
      var fallback = null;
      radios.forEach(function(r) {
        if (fallback) return;
        if (isSelectable(r)) fallback = r;
      });
      if (fallback) {
        fallback.checked = true;
      }
    });
    syncButtonWithCheckedOptions();
  }

  /* Corrige el botón "Add to cart" real (y el proxy) según lo que quedó marcado,
     leyendo el JSON del producto ya cargado en la página — sin pedirle a Dawn que
     vuelva a renderizar la sección (eso es lo que causaba el parpadeo doble). */
  function syncButtonWithCheckedOptions() {
    var jsonEl = document.querySelector('script[id^="dp-product-json-"]');
    if (!jsonEl) return;
    var product;
    try { product = JSON.parse(jsonEl.textContent); } catch (e) { return; }
    if (!product || !product.variants || !product.options) return;

    var fieldsets = {};
    document.querySelectorAll('.product-form__input--pill[data-option-name], .product-form__input--swatch[data-option-name]').forEach(function(fieldset) {
      var optName = fieldset.getAttribute('data-option-name');
      if (optName && !fieldsets[optName]) fieldsets[optName] = fieldset;
    });

    var selected = {};
    Object.keys(fieldsets).forEach(function(optName) {
      var checkedInput = fieldsets[optName].querySelector('input[type="radio"]:checked');
      if (checkedInput) selected[optName] = checkedInput.value;
    });
    if (!Object.keys(selected).length) return;

    function findMatch(sel) {
      return product.variants.filter(function(v) {
        return product.options.every(function(optName, idx) {
          var key = 'option' + (idx + 1);
          return !sel[optName] || v[key] === sel[optName];
        });
      })[0];
    }

    var match = findMatch(selected);

    if (!match) {
      /* Nada combina con TODO lo marcado (ej. el color no tiene esa condición) —
         buscamos la variante disponible más parecida, priorizando mantener el color elegido,
         y corregimos las demás opciones marcadas para que reflejen una combinación real */
      var available = product.variants.filter(function(v) { return v.available; });
      var candidates = available.length ? available : product.variants;
      var firstOptionName = product.options[0];
      var sameFirstOption = candidates.filter(function(v) {
        return !selected[firstOptionName] || v.option1 === selected[firstOptionName];
      });
      match = sameFirstOption[0] || candidates[0];

      if (match) {
        product.options.forEach(function(optName, idx) {
          var key = 'option' + (idx + 1);
          var value = match[key];
          var fieldset = fieldsets[optName];
          if (!fieldset || !value) return;
          fieldset.querySelectorAll('input[type="radio"]').forEach(function(r) {
            r.checked = (r.value === value);
          });
        });
      }
    }
    if (!match) return;

    var idInput = document.querySelector('.product-form [name="id"]');
    if (idInput && idInput.value != match.id) idInput.value = match.id;

    var submitBtn = document.querySelector('.product-form [name="add"]');
    if (submitBtn) {
      submitBtn.disabled = !match.available;
      var textSpan = submitBtn.querySelector('span') || submitBtn;
      textSpan.textContent = match.available ? 'Add to cart' : 'Sold out';
    }

    updateProxyBtn();
  }

  /* Precio + botón proxy */
  function initProductActions() {
    if (!document.body.classList.contains('template-product')) return;

    var priceEl = document.querySelector('.product__info-container .price');
    if (!priceEl) return;

    var wrapper = document.querySelector('.dp-price-with-btn');
    if (!wrapper) {
      wrapper = document.createElement('div');
      wrapper.className = 'dp-price-with-btn';
      priceEl.parentNode.insertBefore(wrapper, priceEl);
      wrapper.appendChild(priceEl);

      var proxy = document.createElement('button');
      proxy.className = 'dp-btn-cart-inline';
      proxy.id = 'dp-proxy-btn';
      proxy.type = 'button';
      proxy.addEventListener('click', function() {
        var btn = document.querySelector('.product-form [name="add"]');
        if (btn && !btn.disabled) btn.click();
      });
      wrapper.appendChild(proxy);
    }

    updateProxyBtn();
    updateSavingsBadge();
  }

  function updateProxyBtn() {
    var proxy = document.getElementById('dp-proxy-btn');
    if (!proxy) return;
    var submitBtn = document.querySelector('.product-form [name="add"]');
    if (!submitBtn) return;
    var txt = submitBtn.textContent.trim();
    proxy.textContent = txt;
    var isDisabled = submitBtn.disabled
      || txt.toLowerCase().includes('agotado')
      || txt.toLowerCase().includes('sold out')
      || txt.toLowerCase().includes('unavailable');
    proxy.disabled = isDisabled;
    proxy.style.display = isDisabled ? 'none' : '';
    proxy.style.background = '#FF5436';
    proxy.style.cursor = 'pointer';

    /* Toggle: rojo "Agotado" vs verde "Ahorra" */
    var saveBadge = document.querySelector('.dp-save-badge');
    var soldBadge = document.querySelector('.dp-sold-badge');

    if (isDisabled) {
      if (saveBadge) saveBadge.style.display = 'none';
      if (!soldBadge) {
        soldBadge = document.createElement('span');
        soldBadge.className = 'dp-sold-badge';
        soldBadge.textContent = 'Sold out';
        var compareLine = document.querySelector('.dp-compare-line');
        var target = compareLine || document.querySelector('.dp-price-with-btn .price');
        if (target) target.appendChild(soldBadge);
      }
      if (soldBadge) soldBadge.style.display = 'inline-block';
    } else {
      if (soldBadge) soldBadge.style.display = 'none';
      if (saveBadge) saveBadge.style.display = '';
    }
  }

  function updateSavingsBadge() {
    // No mostrar si está agotado
    var submitBtn = document.querySelector('.product-form [name="add"]');
    var isDisabled = submitBtn && (submitBtn.disabled ||
      submitBtn.textContent.toLowerCase().includes('agotado') ||
      submitBtn.textContent.toLowerCase().includes('sold out'));
    var badge = document.querySelector('.dp-save-badge');
    if (isDisabled) { if (badge) badge.style.display = 'none'; return; }

    var compareEl = document.querySelector('.template-product .dp-compare-line s');
    var saleEl = document.querySelector('.template-product .price-item--sale, .template-product .price-item--last');
    var compareLine = document.querySelector('.dp-compare-line');

    if (!compareEl || !saleEl || !compareLine) { if (badge) badge.style.display = 'none'; return; }

    function parsePrice(txt) { return parseFloat(txt.replace(/[^0-9.]/g, '')) || 0; }
    var compare = parsePrice(compareEl.textContent);
    var sale = parsePrice(saleEl.textContent);

    if (compare <= sale || compare === 0) { if (badge) badge.style.display = 'none'; return; }

    var savings = compare - sale;
    var saveTxt = 'Save $' + savings.toFixed(2).replace(/\.00$/, '');

    if (!badge) {
      badge = document.createElement('span');
      badge.className = 'dp-save-badge';
      compareLine.appendChild(badge);
    }
    badge.textContent = saveTxt;
    badge.style.display = '';
  }

  /* Mapa de colores */
  var colorMap = {
    'negro':'#1C1C1E','black':'#1C1C1E','midnight':'#1C1C1E','space black':'#1C1C1E','graphite':'#1C1C1E','space gray':'#1C1C1E','space grey':'#1C1C1E','black titanium':'#1C1C1E',
    'blanco':'#F5F5F0','white':'#F5F5F0','starlight':'#F5F5F0','silver':'#E0E0E0','plata':'#E0E0E0',
    'azul':'#2C6FBF','blue':'#2C6FBF','alpine blue':'#2C6FBF','sierra blue':'#2C6FBF','pacific blue':'#2C6FBF','blue titanium':'#2C6FBF',
    'rojo':'#C6002B','red':'#C6002B','(product)red':'#C6002B',
    'verde':'#2D6A4F','green':'#2D6A4F','midnight green':'#2D6A4F','alpine green':'#2D6A4F',
    'amarillo':'#FFD60A','yellow':'#FFD60A',
    'morado':'#8B5CF6','purple':'#8B5CF6','deep purple':'#8B5CF6',
    'rosa':'#FF6B9D','pink':'#FF6B9D',
    'gris':'#8E8E93','gray':'#8E8E93','grey':'#8E8E93','natural titanium':'#C0B09A','titanio natural':'#C0B09A','desert titanium':'#C8A97A',
    'naranja':'#FF6B35','orange':'#FF6B35','coral':'#FF6B35',
    'dorado':'#C8A96E','gold':'#C8A96E','champagne gold':'#C8A96E',
    'plateado':'#D1D1D6','silver titanium':'#D1D1D6','white titanium':'#F0EDE8'
  };

  function findColor(val) {
    val = val.toLowerCase().trim();
    if (colorMap[val]) return colorMap[val];
    var found = null;
    Object.keys(colorMap).forEach(function(k) {
      if (!found && (val.includes(k) || k.includes(val))) found = colorMap[k];
    });
    return found;
  }

  /* Inyecta CSS persistente para círculos de color */
  function styleColorPicker() {
    if (!document.body.classList.contains('template-product')) return;
    if (document.getElementById('dp-color-css')) return;

    var css = '';
    var found = false;

    document.querySelectorAll('.product-form__input').forEach(function(fieldset) {
      var optionName = (fieldset.getAttribute('data-option-name') || '').toLowerCase();
      var legend = fieldset.querySelector('legend');
      var legendText = legend ? legend.textContent.toLowerCase() : '';
      if (optionName !== 'color' && optionName !== 'colour' && !legendText.includes('color')) return;
      if (optionName && optionName !== 'color' && optionName !== 'colour') return; /* si tiene data-option-name y no es Color, no tocar */
      found = true;

      var scope = '.product-form__input--pill[data-option-name="' + (fieldset.getAttribute('data-option-name') || '') + '"]';

      css += scope + ' input[type="radio"]+label{width:36px!important;height:36px!important;border-radius:50%!important;padding:0!important;font-size:0!important;line-height:0!important;overflow:hidden!important;display:inline-flex!important;align-items:center!important;justify-content:center!important;margin:4px 6px 4px 0!important;flex-shrink:0!important;min-width:0!important;background:#d1d5db!important;border:1.5px solid rgba(10,26,47,.18)!important;}';
      css += scope + ' input[type="radio"]+label::before{display:none!important;}';
      css += scope + ' input[type="radio"]:checked+label{outline:3px solid #0E6FFF!important;outline-offset:2px!important;background-color:inherit!important;color:inherit!important;}';

      fieldset.querySelectorAll('input[type="radio"]').forEach(function(input) {
        var val = (input.value || '').replace(/\\/g,'\\\\').replace(/"/g,'\\"');
        var color = findColor(input.value || '');
        if (color) {
          css += scope + ' input[type="radio"][value="' + val + '"]+label{background:' + color + '!important;}';
        }
      });
    });

    if (found && css) {
      var style = document.createElement('style');
      style.id = 'dp-color-css';
      style.textContent = css;
      document.head.appendChild(style);
    }
  }

  /* Carrusel táctil */
  function initCarrusel() {
    document.querySelectorAll('.dp-carrusel-track').forEach(function (track) {
      var startX = 0, scrollLeft = 0;
      track.addEventListener('mousedown', function (e) { startX = e.pageX - track.offsetLeft; scrollLeft = track.scrollLeft; track.style.cursor = 'grabbing'; });
      track.addEventListener('mouseleave', function () { track.style.cursor = ''; });
      track.addEventListener('mouseup', function () { track.style.cursor = ''; });
      track.addEventListener('mousemove', function (e) { if (e.buttons !== 1) return; track.scrollLeft = scrollLeft - (e.pageX - track.offsetLeft - startX); });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initGlyphs();
    initFaq();
    initCountdown();
    initReveal();
    initShipBar();
    initCarrusel();
    initPriceSplit();
    initFacetsPills();
    setTimeout(initFacetsPills, 500);
    initFilterNames();
    setTimeout(initFilterNames, 800);
    initProductActions();
    ensureVariantChecked();
    setTimeout(styleColorPicker, 200);

    /* Observer liviano — solo detecta cambios en el precio del producto */
    if (document.body.classList.contains('template-product')) {
      var priceContainer = document.querySelector('.product__info-container');
      if (priceContainer) {
        var obs = new MutationObserver(function() {
          clearTimeout(obs._t);
          clearTimeout(obs._t2);
          obs._t = setTimeout(reinitProductActions, 250);
          /* Red de seguridad: si el DOM tardó más en asentarse, revisamos de nuevo un poco después */
          obs._t2 = setTimeout(reinitProductActions, 700);
        });
        /* Solo observar cambios directos en hijos del info container */
        obs.observe(priceContainer, { childList: true, subtree: false });
        /* También observar el bloque de precio específicamente */
        var priceBlock = priceContainer.querySelector('.price, [id*="price"]');
        if (priceBlock) {
          obs.observe(priceBlock.parentNode || priceBlock, { childList: true, subtree: false });
        }
      }
    }
  });
})();
